// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
        <path d="M14.6001 19.784L21.2001 13.184L20.2667 12.2173L14.6001 17.884L11.7334 15.0507L10.8001 15.984L14.6001 19.784ZM16.0001 27.9173C13.3112 27.1395 11.0832 25.5227 9.31608 23.0667C7.54986 20.6115 6.66675 17.8507 6.66675 14.784V7.58398L16.0001 4.08398L25.3334 7.58398V14.784C25.3334 17.8507 24.4499 20.6115 22.6827 23.0667C20.9165 25.5227 18.689 27.1395 16.0001 27.9173ZM16.0001 26.5173C18.3112 25.784 20.2223 24.3173 21.7334 22.1173C23.2445 19.9173 24.0001 17.4729 24.0001 14.784V8.48398L16.0001 5.51732L8.00008 8.48398V14.784C8.00008 17.4729 8.75564 19.9173 10.2667 22.1173C11.7779 24.3173 13.689 25.784 16.0001 26.5173Z" />
      </svg>
    </Icons>
  );
}
